import React, { useEffect, useState } from 'react'
import CustomAlert from '../../components/CustomAlert';
import { connection } from '../../config';
import wsclients from '../../services/wsclients';
import CardsView from './CardsView'
import AddCard from './AddCard'
import CustomLoading from '../../components/CustomLoading';
import { useTranslation } from 'react-i18next';
import { setAddCardInfo } from '../../utils/commons';
export default function CardsController() {
    const { t } = useTranslation();
    const [cards, setCards] = useState([]);
    const [message, setMessage] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [openAddCard, setOpenAddCard] = useState(false);
    const [html_add_card_content, setHtmlAddCardContent] = useState(null);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });

    useEffect(() => {
        onLoadPaymentMethods();
    }, []);


    const onLoadPaymentMethods = async (isRefresh) => {
        onShowLoading(true);
        try {
            let result = await wsclients.contacts.getListPaymentMethods();
            console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                let paymentMethods = result.data.content ? result.data.content : [];
                let _cards = [];
                paymentMethods.forEach(item => {
                    console.log("item:", item);
                    if (item.card) {
                        let newCard = {
                            id: item.id,
                            card_number: item.card.first6 + "xxxxxx" + item.card.last4,
                            expiration: item.card.expiration_month && item.card.expiration_year ? item.card.expiration_month + '/' + item.card.expiration_year : null,
                            is_primary: item.is_primary + '',
                        };
                        _cards.push(newCard);
                    }
                });
                setCards(_cards);
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
        onShowLoading(false);
    }

    const onAddCard = async () => {
        onShowLoading(true);
        try {
            let urlFormPaygate = connection.urlFormPaygate;
            let paygateIntegration = connection.paygateIntegration
            let result = await wsclients.paymentgateway.getClientToken({ integration_id: paygateIntegration });
            console.log('getClientToken result===', result)
            if (result && result.code == 'OK' && result.data && result.data.client_token) {
                let clientToken = result.data.client_token;
                var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                console.log('splitToken:', splitToken);
                if (splitToken.length > 0) {
                    var payRequestIDRes = splitToken[0];
                    var checkSumRes = splitToken[1];
                    var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                        + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                        + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                        + '</form>'
                    console.log('htmlContent:', htmlContent);
                    setHtmlAddCardContent(htmlContent);
                    setAddCardInfo({
                        is_add: true,
                    });
                    setOpenAddCard(true);
                }
            }else{
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }
        }
        catch (e) {
            onShowLoading(false)
            console.log('getClientToken error: ', e)
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }

        onShowLoading(false)
    }
    const onDeleteCard = async (card) => {
        console.log("onDeleteCard card:",card);
        onShowLoading(true);
        try {
            let result = await wsclients.paymentgateway.removePaymentMethod({payment_method_id: card.id});
            console.log(' onRemoveCard card==', card)
            if (result.code == 'OK') {
                await onLoadPaymentMethods();
                showAlert(t('SUCCESS'), t('REMOVE_CARD_SUCCESS'));
            } else {
                showAlert(t('ERROR'), t('FAILED_TO_REMOVE_CARD'));
            }
        } catch (ex) {
            console.log("remove card exception:", ex);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const setPrimaryCard = async (card) => {
        if(card.is_primary === 'true' || card.is_primary === true){ 
            showAlert(t('SUCCESS'), t('This card is already set as the primary card'));
        }else{ 
            onShowLoading(true);
            try {
                console.log("setPrimaryCard card:",card);
                let result = await wsclients.paymentgateway.setPrimaryCard(card.id);
                if (result.code == 'OK') {
                    await onLoadPaymentMethods();
                    showAlert(t('SUCCESS'), t('You have successfully set this card as primary'));
                } else {
                    showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
                }
            } catch (error) {
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }
            onShowLoading(false);
        }
    }

    const onCloseAddCard = () => {
        onLoadPaymentMethods();
        setOpenAddCard(false);
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    const showAlert = (status, message, close) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }
    return (
        <>
            <CardsView
                message={message}
                cards={cards}
                onAddCard={onAddCard}
                onDeleteCard={onDeleteCard}
                setPrimaryCard={setPrimaryCard}
            />
            {openAddCard && <AddCard
                open={openAddCard}
                onClose={onCloseAddCard}
                html_add_card_content={html_add_card_content} />}
            {error.showAlert && <CustomAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                showButtonClose={true}
                message={error.message}
                error={error.status}
            />}
             {showLoading && <CustomLoading open={showLoading} />}
        </>
    )
}
